import { render, staticRenderFns } from "./TestResponsive.vue?vue&type=template&id=142ed5a5&"
import script from "./TestResponsive.vue?vue&type=script&lang=js&"
export * from "./TestResponsive.vue?vue&type=script&lang=js&"
import style0 from "./TestResponsive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports